import React, { useContext, useState, useCallback, useEffect, createContext } from 'react';
import classnames from 'classnames';
import { useOnScroll } from '@wix/da-hooks/pkg/useOnScroll';
import { PopupContext } from '../popups/PopupContext';
import { scrollTo } from '../../utils/browser';
import s from './ScrollableContent.scss';
const THROTTLE_TIMEOUT = 200;
export const ScrollableContentContext = /*#__PURE__*/ createContext(undefined);
const ScrollableContent = ({ id, role, wrapperClassName, styles, className, children, throttleTimeout = THROTTLE_TIMEOUT, onScrolled, onNotScrollable, scrolledToBottom = false, innerRef, 'aria-hidden': ariaHidden })=>{
    const contentRef = React.useRef(null);
    const { setScrollableContentRef } = useContext(PopupContext);
    const [isScrolled, setScrolled] = useState(false);
    const handleScroll = useCallback((scrollTop, distanceToBottom)=>{
        onScrolled && onScrolled(scrollTop, distanceToBottom);
        const scrolled = scrollTop > 0;
        if (isScrolled !== scrolled) {
            setScrolled(scrolled);
        }
    }, [
        onScrolled,
        isScrolled
    ]);
    useEffect(()=>{
        const contentNode = contentRef.current;
        if (contentNode && scrolledToBottom) {
            scrollTo(contentNode, 0, contentNode.scrollHeight);
        }
    }, [
        scrolledToBottom
    ]);
    useEffect(()=>{
        const contentNode = contentRef.current;
        if (!contentNode) {
            return;
        }
        if (contentNode.clientHeight === contentNode.scrollHeight) {
            onNotScrollable && onNotScrollable();
        }
    }, [
        children,
        onNotScrollable
    ]);
    useOnScroll(contentRef, handleScroll, throttleTimeout, true);
    const setRef = (node)=>{
        contentRef.current = node;
        innerRef && innerRef(node);
        setScrollableContentRef(node);
    };
    return /*#__PURE__*/ React.createElement("div", {
        id: id,
        role: role,
        className: classnames(s['root'], wrapperClassName),
        "aria-hidden": ariaHidden
    }, /*#__PURE__*/ React.createElement(ScrollableContentContext.Provider, {
        value: contentRef
    }, /*#__PURE__*/ React.createElement("div", {
        style: styles,
        className: classnames(s['content'], className),
        ref: setRef
    }, children)));
};
ScrollableContent.displayName = 'ScrollableContent';
export default ScrollableContent;
